import React, { useState, useEffect, useCallback } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
} from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import Footer from "./components/home/Footer/Footer";
import FooterBottom from "./components/home/Footer/FooterBottom";
import Header from "./components/home/Header/Header";
import HeaderBottom from "./components/home/Header/HeaderBottom";
import SpecialCase from "./components/SpecialCase/SpecialCase";
import About from "./pages/About/About";
import SignIn from "./pages/Account/SignIn";
import Adminsignin from "./pages/Account/Adminsignin";
import Terms from "./pages/Account/Terms";
import Forgotpassword from "./pages/Account/Forgotpassword";
import MobileSignIn from "./pages/Account/MobileSignIn";
import SignUp from "./pages/Account/SignUp";
import Cart from "./pages/Cart/Cart";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import Chit from "./pages/Chit/Chit";
import PlanSuccess from "./pages/Chit/PlanSuccess";
import Plans from "./pages/Chit/Plans";
import GoldLoan from "./pages/GoldLoan/GoldLoan";
import PersonalLoan from "./pages/PersonalLoan/PersonalLoan";
import GoldLoanSuccess from "./pages/GoldLoan/GoldLoanSuccess";
import PersonalLoanSuccess from "./pages/PersonalLoan/PersonalLoanSuccess";
import Offer from "./pages/Offer/Offer";
import Payment from "./pages/payment/Payment";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Shop from "./pages/Shop/Shop";
import SilverPrice from "./components/home/Header/SilverPrice";
import PrivacyPolicy from "./pages/Account/PrivacyPolicy";
import EmailOTPValidation from "./pages/Account/EmailOTPValidation";
import OrderSuccess from "./pages/Cart/OrderSuccess";
import MyProfile from "./components/home/Header/MyProfile" 
import './App.css';
import AdminTab from "./pages/Admin/AdminTab";
import AdminViewOrderList from "./pages/Admin/AdminViewOrderList";
import AdminViewProductList from "./pages/Admin/AdminViewProductList";
import AdminViewPlanList from "./pages/Admin/AdminViewPlanList";
import AdminViewPlanInvoiceList from './pages/Admin/AdminViewPlanInvoiceList'
import FixedDepositCalculator from "./pages/Fixeddeposit/FixedDeposit";
import FixedDeposit from "./pages/Fixeddeposit/FixedDeposit";
import FixedDepositSuccess from "./pages/Fixeddeposit/FixedDepositSuccess";
import ChitPlanTable from "./pages/Chit/OnelakChitplan";
import FiveLakhChitPlanTable from "./pages/Chit/FiveLakhChitPlan";
import GoldChit from "./pages/Chit/GoldChit";
import GoldChitDashboard from "./pages/Chit/GoldChitDashboard";
import MoneyChitDashboard from "./pages/Chit/MoneyChitDashboard";
import { ADMIN } from "./config/Config";
import { useContextSelector } from "use-context-selector";
import { StateContext } from "./contexts/StateContext";
import UserTable from "./pages/Chit/UserGoldChit";
import AdminChitCreator from "./pages/Admin/AdminChitCreator";
import ProfileView from "./pages/Chit/ProfileView";
import ProfileViewMoneyChit from "./pages/Chit/ProfileViewMoneyChit";
import ViewCustomers from "./pages/Chit/ViewCustomers";
import UserGoldPlans from "./pages/Plans/UserGoldPlans";
import MoneyChitPlans from "./pages/Plans/MoneyChitPlans";
import MyProfileFromAdmin from "./components/home/Header/MyProfileFromAdmin";
import AddGoldPlan from "./pages/Chit/AddGoldPlan";
import GoldChitAd from "./pages/Chit/GoldChitAd";
import { ACCESS_TOKEN, ADMIN_TOKEN, HR_TOKEN, CLIENT_TOKEN, FINANCIER_TOKEN, EMPLOYEE_TOKEN } from './config/Config';
import AddPersonalLoan from './pages/Chit/AddPersonalLoan';
import ProfileViewPersonalLoan from './pages/Chit/ProfileViewPersonalLoan';
import UserPersonalLoans from './pages/Plans/UserPersonalLoans';

const Layout = () => {
  return (
    <div>
      <Header />
      <SpecialCase />
      <ScrollRestoration />
      <Outlet />
      <Footer />
      <FooterBottom />
    </div>
  );
};

function App() {
  const setRole = useContextSelector(StateContext, (state) => state.setRole);
  const setIsLoggedIn = useContextSelector(StateContext, (state) => state.setIsLoggedIn);
  const role = useContextSelector(StateContext, (state) => state.role);
  const [router, setRouter] = useState(null);

  // Define isAuthenticated with useCallback to prevent recreating on every render
  const isAuthenticated = useCallback(() => {
    console.log("isAuthenticated function executing");
    
    if (localStorage.getItem(ACCESS_TOKEN)) {
      let token = localStorage.getItem(ACCESS_TOKEN);
      try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        token = JSON.parse(window.atob(base64));
        
        if (token.exp <= Math.floor(Date.now() / 1000)) {
          localStorage.removeItem(ACCESS_TOKEN);
          localStorage.removeItem(ADMIN_TOKEN);
          setIsLoggedIn(false);
          return false;
        }
        
        if (token.rol && token.rol.length >= 1) {
          if (token.rol[0] === "ADMIN") {
            localStorage.setItem(ADMIN_TOKEN, token.rol[0]);
            setRole(token.rol[0]);
          }
          setRole(token.rol[0]);
          setIsLoggedIn(true);
          return true;
        }
      } catch (error) {
        console.error("Token parsing error:", error);
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(ADMIN_TOKEN);
        setIsLoggedIn(false);
        return false;
      }
    }
    setIsLoggedIn(false);
    return false;
  }, [setIsLoggedIn, setRole]);

  // useEffect with proper dependencies
  useEffect(() => {
    console.log("App component mounted, checking authentication");
    isAuthenticated();
  }, [isAuthenticated]);

  // Create router when role changes
  useEffect(() => {
    console.log("Role updated, recreating router with role:", role);
    
    const newRouter = createBrowserRouter(
      createRoutesFromElements(
        <Route>
          <Route path="/" element={<Layout />}>
            {/* ==================== Header Navlink Start here =================== */}
            <Route index element={<Home />}></Route>
            <Route path="/shop" element={<Shop />}></Route>
            <Route path="/about" element={<About />}></Route>
            <Route path="/orderSuccess" element={<OrderSuccess />}></Route>
            <Route path="/goldloansucess" element={<GoldLoanSuccess />}></Route>
            <Route path="/fixeddepositsucess" element={<FixedDepositSuccess />}></Route>
            <Route path="/planSuccess" element={<PlanSuccess />}></Route>
            <Route path="/contact" element={<Contact />}></Route>
            <Route path="/SilverPrice" element={<SilverPrice />}></Route>
            <Route path="/goldloan" element={<GoldLoan />}></Route>
            <Route path="/personalLoan" element={<PersonalLoan />}></Route>
            <Route path="/personalLoanSucess" element={<PersonalLoanSuccess />}></Route>
            <Route path="/fixeddeposit" element={<FixedDeposit />}></Route>
            <Route path="/emailotpvalidation" element={<EmailOTPValidation />}></Route>
            {/* ==================== Header Navlink End here ===================== */}
            <Route path="/offer" element={<Offer />}></Route>
            <Route path="/chit" element={<Chit />}></Route>
            <Route path="/usergoldchit" element={<UserTable />}></Route>
            <Route path="/chitplans" element={<ChitPlanTable />}></Route>
            <Route path="/fivelakhchitplan" element={<FiveLakhChitPlanTable />}></Route>
            <Route path="/plans" element={<Plans />}></Route>
            <Route path="/Adminsignin" element={<Adminsignin />}></Route>
            <Route path="/adminDashboard" element={<AdminTab />}></Route>
            <Route path="/viewOrderList" element={<AdminViewOrderList />}></Route>
            <Route path="/viewProductList" element={<AdminViewProductList />}></Route>
            <Route path="/viewPlanList" element={<AdminViewPlanList />}></Route>
            <Route path="/viewPlanInvoiceList" element={<AdminViewPlanInvoiceList />}></Route>
            <Route path="/myprofile" element={<MyProfile />}></Route>
            <Route path="/moneyChitPlan" element={<MoneyChitPlans/>}></Route>
            <Route path="/UserGoldPlan" element={<UserGoldPlans />}></Route>
            <Route path="/UserPersonalLoans" element={<UserPersonalLoans />}></Route>
            <Route path="/goldOnboard" element={<GoldChit />}></Route>
            <Route path="/goldChitAd" element={<GoldChitAd />}></Route>
            <Route path="/Forgotpassword" element={<Forgotpassword />}></Route>
            <Route path="/Terms" element={<Terms />}></Route>
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />}></Route>

            {/* Conditionally add Admin routes */}
            {role === ADMIN && (
              <Route path="/AdminChit" element={<AdminChitCreator />} />
            )}
            
            {role === ADMIN && (
              <>
                <Route path="/viewCustomers" element={<ViewCustomers />} />
                <Route path="/goldChitDashboard" element={<GoldChitDashboard />} />
                <Route path="/moneyChitDashboard" element={<MoneyChitDashboard />} />
                <Route path="/profileview/:email" element={<ProfileView />} />
                <Route path="/profileviewFromAdmin/:customerEmail" element={<MyProfileFromAdmin />} />
                <Route path="/profileviewMoneyChit/:email" element={<ProfileViewMoneyChit />} />
                <Route path="/admin/add-gold-plan/:customerEmail" element={<AddGoldPlan />} />
                <Route path="/admin/add-personal-loan/:customerEmail" element={<AddPersonalLoan />} />
                <Route path="/profileviewPersonalLoan/:email" element={<ProfileViewPersonalLoan />} />

              </>
            )}
            
            <Route path="/product/:_id" element={<ProductDetails />}></Route>
            <Route path="/cart" element={<Cart />}></Route>
            <Route path="/paymentgateway" element={<Payment />}></Route>
          </Route>
          <Route path="/signup/:message" element={<SignUp />}></Route>
          <Route path="/signup" element={<SignUp />}></Route>
          <Route path="/signin" element={<SignIn />}></Route>
          <Route path="/Forgotpassword" element={<Forgotpassword />}></Route>
          <Route path="/Terms" element={<Terms />}></Route>
          <Route path="/MobileSignIn" element={<MobileSignIn />}></Route>
        </Route>
      )
    );

    setRouter(newRouter);
  }, [role]); // Recreate router when role changes

  // Show loading while router is being created
  if (!router) {
    return (
      <div className="font-bodyFont flex justify-center items-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="font-bodyFont">
      <RouterProvider router={router} />
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}
    </div>
  );
}

export default App;